export const FALLBACK_VALUE = 'Onbekend';
export const FALLBACK_STATUS = 'Lopend';

